import React, { useMemo } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import styled from "styled-components";
import FileUpload from "./FileUpload";

import { UploadCsvOption } from "../../../constants/assets/containers";
import * as UserActions from "../../../store/actions/User";

const BulkUploadFile = ({
  instructions, //set of instructions or note
  keyName, //keyName of the key to be send in acknowledgement
  uploadUrl, //upoadUrl is the url on which the ack will be sent
  sendExtraAck, //pass boolean value if to pass filepath as extra param or not in ack call
  callback_key,
  presign_url,
  file_path,
  maxSize = 1.5,
  validateCSVSize = false,
  setUploadedFileName,
  setActiveFilePath,
  activeFile,
  setActiveFile,
  activeFileName,
  setActiveFileName,
}) => {
  const handleFileUploadSuccess = () => {
    if (activeFileName) {
      setUploadedFileName(activeFileName);
      console.log("Success");
    }
    setActiveFilePath(file_path);
  };

  const extraParamsAckObj = useMemo(() => {
    return sendExtraAck
      ? {
          file_path: file_path,
          presign_url: presign_url,
          filename: activeFileName,
          file_type: activeFile.type,
        }
      : {};
  }, [sendExtraAck, file_path, presign_url]);

  return (
    <Section>
      <UploadCsvOption>
        <FileUpload
          title="CSV file"
          uploadUrl={uploadUrl}
          callback_key={callback_key}
          presign_url={presign_url}
          keyName={keyName || "callback_key"}
          activeFile={activeFile}
          maxSize={maxSize}
          validateCSVSize={validateCSVSize}
          setActiveFile={setActiveFile}
          extraParamsAckObj={extraParamsAckObj}
          acceptTypes={".csv, .xls, .xlsx"}
          handleFileUploadSuccess={handleFileUploadSuccess}
          activeFileName={activeFileName}
          setActiveFileName={setActiveFileName}
        />
      </UploadCsvOption>
    </Section>
  );
};

const Section = styled.section`
  display: flex;
  align-items: center;
  gap: 2rem;
`;

function mapDispatchToProps(dispatch) {
  return {
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    setUploadedFileName: bindActionCreators(
      UserActions.setUploadedFileName,
      dispatch
    ),
    setActiveFilePath: bindActionCreators(
      UserActions.setActiveFilePath,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(BulkUploadFile);
